import auth1 from "../assets/international/DSC08593.webp";
import logo from "../assets/logos/RG copy 2.png";
import v1 from "../assets/videos/int.webm";
import { useRef, useState } from "react";
import bride1 from "../assets/pictures/home/bride1.jpeg";
import bride2 from "../assets/pictures/home/bride2.jpeg";
import bride3 from "../assets/pictures/home/bride3.jpeg";
import bride4 from "../assets/pictures/home/bride4.jpeg";
import auth2 from "../assets/pictures/home/post111.jpeg";
import { cls } from "../components/Utility";
import { Link } from "react-router-dom";
import DesktopWa from "../components/DesktopWa";
import Call from "../components/Call";
import i1 from "../assets/international/i1.webp";
import i2 from "../assets/international/i2.webp";
import i3 from "../assets/international/i3.webp";
import i4 from "../assets/international/i4.webp";
import i5 from "../assets/international/i5.webp";
import i6 from "../assets/international/i6.webp";
import i7 from "../assets/international/i7.webp";
import i8 from "../assets/international/i8.webp";
import i9 from "../assets/international/i9.webp";
import i10 from "../assets/international/i10.webp";
import i11 from "../assets/international/i11.webp";
import i12 from "../assets/international/i12.webp";
import i13 from "../assets/international/i13.webp";
import i14 from "../assets/international/i14.webp";
import i15 from "../assets/international/i15.webp";



export default function InternationalShoot() {
  const scrollContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    e.preventDefault(); // Prevent text selection
    setIsDragging(true);
    setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
  };

  const handleMouseUpOrLeave = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollContainerRef.current.offsetLeft;
    const walk = (x - startX) * 1; // Adjust the multiplier for speed (lower = slower)
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <>
      <div className={cls("hidden", "xl:flex")}>
        <div className="relative w-full h-screen overflow-hidden">
          <div className="w-full h-full">
            <img src={auth1} />
          </div>
          <div className="absolute inset-x-0 bottom-[60px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[25px] font-semibold tracking-widest fadeInUp ">
                GLOBAL FRAMES X CINEMATIC INTERNATIONAL SHOOTS
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        <div className="relative w-full overflow-hidden">
          <img src={auth1} className="w-full h-[500px] object-cover" />

          <div className="absolute inset-x-0 top-[420px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[20px] font-semibold tracking-widest fadeInUp ">
                GLOBAL FRAMES X CINEMATIC INTERNATIONAL SHOOTS
              </h1>
            </div>
          </div>
        </div>
      </div>

      <p className=" mt-[30px] text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px]">
        We travel beyond borders to frame your love against the world’s most
        iconic backdrops with cinematic storytelling and soulful precision.
        Every shoot blends culture, elegance, and emotion, turning international
        locations into timeless chapters of your love story.
      </p>
      <div className="flex justify-center mb-[20px]">
        <img src={logo} className="w-[70px] h-[70px] object-contain" />
      </div>

      <div className="flex justify-center mb-[40px] xl:pl-0 xl:pr-0 pl-[20px] pr-[20px]">
        <video
          className="xl:w-[700px] xl:h-[1000px] w-full h-[600px] object-cover"
          autoPlay
          loop
          muted
        >
          <source src={v1} type="video/mp4" />
        </video>
      </div>

      <div className={cls("hidden", "xl:flex")}>
        {" "}
        <div
          ref={scrollContainerRef}
          className={`fullscreen-scroll-container ${
            isDragging ? "dragging" : ""
          }`}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseUpOrLeave}
          onMouseUp={handleMouseUpOrLeave}
          onMouseMove={handleMouseMove}
        >
          <div className="scroll-item">
            <img src={i1} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={i2} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={i3} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={i4} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={i5} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={i6} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={i7} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={i8} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={i9} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={i10} alt="Image 1" />
          </div>
         
        </div>
      </div>
      <div className={cls("flex mb-[40px]", "xl:hidden")}>
        <div class="w-full overflow-x-auto no-scrollbar">
          <div class="flex ">
            <img
              src={i1}
              class="w-[300px] h-[400px] object-cover p-[5px] "
            />
            <img
              src={i2}
              class="w-[300px] h-[400px] object-cover p-[5px]"
            />
            <img
              src={i3}
              class="w-[300px] h-[400px] object-cover p-[5px] "
            />
            <img
              src={i4}
              class="w-[300px] h-[400px] object-cover p-[5px]"
            />
            <img
              src={i5}
              class="w-[300px] h-[400px] object-cover p-[5px] "
            />
            <img
              src={i6}
              class="w-[300px] h-[400px] object-cover p-[5px]"
            />
            <img
              src={i7}
              class="w-[300px] h-[400px] object-cover p-[5px] "
            />
            <img
              src={i8}
              class="w-[300px] h-[400px] object-cover p-[5px]"
            />
            <img
              src={i9}
              class="w-[300px] h-[400px] object-cover p-[5px] "
            />
            <img
              src={i10}
              class="w-[300px] h-[400px] object-cover p-[5px]"
            />
            
          </div>
        </div>
      </div>

      <div className="flex flex-col mt-[40px] mb-[20px] xl:gap-[20px] gap-[10px] xl:items-center xl:pl-0 xl:pr-0 pl-[20px] pr-[20px]">
        <img
          src={i11}
          className="xl:w-[606px] w-full h-[500px] xl:h-[650px] object-cover"
        />
           <img
          src={i12}
          className="xl:w-[606px] w-full h-[500px] xl:h-[650px] object-cover"
        />
          <img
          src={i13}
          className="xl:w-[606px] w-full h-[500px] xl:h-[650px] object-cover"
        />
          <img
          src={i14}
          className="xl:w-[606px] w-full h-[500px] xl:h-[650px] object-cover"
        />
          <img
          src={i15}
          className="xl:w-[606px] w-full h-[500px] xl:h-[650px] object-cover"
        />
       </div>
      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9980685056" />
      </div>
    </>
  );
}
